import { render, staticRenderFns } from "./NewModalCreatedFileScroll.vue?vue&type=template&id=65f7ed16&scoped=true"
import script from "./NewModalCreatedFileScroll.vue?vue&type=script&lang=js"
export * from "./NewModalCreatedFileScroll.vue?vue&type=script&lang=js"
import style0 from "./NewModalCreatedFileScroll.vue?vue&type=style&index=0&id=65f7ed16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f7ed16",
  null
  
)

export default component.exports